export class PromotionHeader {
    id: number;
    hotel_id: number;
    menu_section_id: number;
    menu_category_id: number;
    menu_item_id: number;
    name: string;
    active: boolean;
    start_date: string;
    end_date: string;
    promotion_code: string;
    promotion_code_limit: number;
    used_promotion_code: number;
    promotion_defs: PromotionLine[];
    promotions: PromotionLine[];
    week_days: string;
    start_time: string;
    end_time: string;
    service_type: string;
    payment_type: string;

    constructor() {
        this.id = 0;
        this.hotel_id = 0;
        this.menu_section_id = 0;
        this.menu_category_id = 0;
        this.menu_item_id = 0;
        this.name = '';
        this.active = false;
        this.start_date = '';
        this.end_date = '';
        this.promotion_code = '';
        this.promotion_code_limit = 0;
        this.used_promotion_code = 0;
        this.promotion_defs = [];
        this.promotions = [];
        this.week_days = '';
        this.start_time = '';
        this.end_time = '';
        this.service_type = '';
        this.payment_type = '';
    }
}

export class PromotionLine {
    id: number;
    promotion_header_id: number;
    line_type: string;
    menu_item_catalog_group_id: number;
    menu_item_catalog_group_name: string;
    menu_item_catalog_id: number;
    menu_item_catalog_name: string;
    type: string;
    value: number;

    constructor() {
        this.id = 0;
        this.promotion_header_id = 0;
        this.line_type = '';
        this.menu_item_catalog_group_id = 0;
        this.menu_item_catalog_group_name = '';
        this.menu_item_catalog_id = 0;
        this.menu_item_catalog_name = '';
        this.type = '';
        this.value = 0;
    }
}
